export default __webpack_public_path__ + "static/blogBG1-5eddb80023dc99002f2f8cb1c5364fa1.svg";